// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", (evt) => {
  console.log("Item added to the cart")
  console.log(evt.detail.product)
})

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("cart:updated", (evt) => {
  console.log("Cart updated")
  console.log(evt.detail.cart)
})

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener("cart:error", (evt) => {
  console.log("Cart error")
  console.log(evt.detail.errorMessage)
})

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("quick-cart:open", (evt) => {
  console.log("Quick cart opened")
  console.log(evt.detail.cart)
})

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
document.addEventListener("quick-cart:close", () => {
  console.log("Quick cart closed")
})

// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.
document.addEventListener("product:variant-change", (evt) => {
  console.log("Product variant changed")
  console.log(evt.detail.variant)

  let dataProductInventoryJson = document.querySelector('.shopify-section.main-product-section').querySelector("[data-product-inventory-json]")
  if (dataProductInventoryJson) {
    const e = JSON.parse(dataProductInventoryJson.innerHTML).inventory
    for(let k in e) {
      if (k == evt.detail.variant.id) {
        console.log(e[k].inventory_waiting_times)
        document.querySelector('.shopify-section.main-product-section').querySelector(".estimated_delivery_time").innerHTML = e[k].inventory_waiting_times
      }
    }
  }

  let prodCalloutsP = document.querySelectorAll('.product__callouts-items p')
  prodCalloutsP.forEach(prodCalloutP => {
    if (prodCalloutP.textContent.includes('Barcode:')) {
        // Modifica il contenuto del paragrafo
        prodCalloutP.innerHTML = '<strong>Barcode:</strong> ' + evt.detail.variant.barcode; // Cambia il testo come desideri
    }
    
    // imposto il campo barcode passato nell'ordine
    const hiddenInput = document.getElementById('barcode');
    if (hiddenInput) {
        hiddenInput.value = evt.detail.variant.barcode;
    }
});
})

// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
document.addEventListener("product:quantity-update", (evt) => {
  console.log("Product quantity updated")
  console.log(evt.detail.quantity, evt.detail.variant)
})

// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.
document.addEventListener("quickview:loaded", () => {
  console.log("Quickview loaded")
})